import { useParams, useNavigate } from 'react-router-dom';
import CityHallClient from './CityHallClient';

// Dados simulados - Em produção, isso viria do backend
const cityHallData = {
  'mangaratiba': {
    name: 'Prefeitura Municipal de Mangaratiba',
    address: 'Praça Robert Simões, 92 - Centro, Mangaratiba - RJ, 23860-000',
    coordinates: { lat: -22.9595, lng: -44.0409 },
    events: [
      { 
        date: '2025-01-16', 
        title: 'Festival de Cultura',
        description: 'Grande festival celebrando a cultura local com música, dança e gastronomia.'
      },
      { 
        date: '2025-01-21', 
        title: 'Feriado de São Sebastião',
        description: 'Dia do santo católico e padroeiro de cidades como Ribeirão Preto e São Sebastião, em São Paulo, além do Rio de Janeiro, capital fluminense.'
      }
    ],
    sponsoredProviders: [
      {
        id: 1,
        name: 'João Silva',
        service: 'Eletricista',
        rating: 5,
        image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      },
      {
        id: 2,
        name: 'Maria Santos',
        service: 'Arquiteta',
        rating: 4,
        image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      },
      {
        id: 3,
        name: 'Pedro Costa',
        service: 'Encanador',
        rating: 5,
        image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      },
      {
        id: 4,
        name: 'Ana Oliveira',
        service: 'Designer',
        rating: 4,
        image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80'
      }
    ],
    news: [
      {
        id: 1,
        title: 'Inauguração da Nova Praça',
        date: '2024-03-15',
        content: 'A Prefeitura inaugura amanhã a nova praça do centro...',
        author: 'Departamento de Comunicação',
        readTime: '3 min',
        image: 'https://images.unsplash.com/photo-1595841696677-6489ff3f8cd1?q=80&w=1000&auto=format&fit=crop'
      },
      {
        id: 2,
        title: 'Programa de Capacitação',
        date: '2024-03-14',
        content: 'Novo programa de capacitação profissional será lançado...',
        author: 'Secretaria de Desenvolvimento',
        readTime: '5 min',
        image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=1000&auto=format&fit=crop'
      }
    ],
    articles: [
      {
        id: 1,
        title: 'Desenvolvimento Sustentável: Novos Projetos para 2024',
        excerpt: 'Conheça os projetos que irão transformar nossa cidade em um exemplo de sustentabilidade...',
        content: `A Prefeitura de Mangaratiba está lançando uma série de iniciativas voltadas para o desenvolvimento sustentável da cidade. O programa, que começará a ser implementado ainda este mês, inclui:

1. Instalação de painéis solares em prédios públicos
2. Criação de hortas comunitárias em diferentes bairros
3. Programa de reciclagem com pontos de coleta em toda a cidade
4. Incentivos fiscais para empresas que adotem práticas sustentáveis

Os projetos foram desenvolvidos em parceria com especialistas em sustentabilidade e contaram com a participação da comunidade através de consultas públicas.`,
        date: '2024-03-18',
        author: 'Maria Silva',
        readTime: '7 min',
        image: 'https://images.unsplash.com/photo-1492496913980-501348b61469?q=80&w=1000&auto=format&fit=crop',
        category: 'Meio Ambiente'
      },
      {
        id: 2,
        title: 'Cultura Local: Festival de Artes em Abril',
        excerpt: 'O Festival de Artes reunirá artistas locais e nacionais em uma celebração da nossa cultura...',
        content: `O Festival de Artes de Mangaratiba promete ser um dos maiores eventos culturais do ano. Durante uma semana, a cidade receberá:

• Apresentações de música ao vivo
• Exposições de arte
• Oficinas de teatro e dança
• Feira gastronômica com pratos típicos
• Shows de artistas locais e convidados especiais

O evento acontecerá na Praça Central e em diversos pontos culturais da cidade, com programação gratuita para toda a população.`,
        date: '2024-03-17',
        author: 'João Santos',
        readTime: '4 min',
        image: 'https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?q=80&w=1000&auto=format&fit=crop',
        category: 'Cultura'
      },
      {
        id: 3,
        title: 'Educação: Novas Escolas Técnicas',
        excerpt: 'Investimentos em educação técnica trarão mais oportunidades para nossa juventude...',
        content: `A Secretaria de Educação anuncia a construção de duas novas escolas técnicas no município. Os novos centros educacionais oferecerão:

• Cursos técnicos em áreas como:
  - Tecnologia da Informação
  - Administração
  - Turismo
  - Meio Ambiente

• Laboratórios modernos e equipados
• Parcerias com empresas locais para estágios
• Programas de primeiro emprego

As obras começam no próximo mês e a previsão é que as escolas estejam funcionando no início do próximo ano letivo.`,
        date: '2024-03-16',
        author: 'Ana Oliveira',
        readTime: '6 min',
        image: 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=1000&auto=format&fit=crop',
        category: 'Educação'
      }
    ]
  }
};

export default function CityHallPage() {
  const { city } = useParams();
  const navigate = useNavigate();
  const cityData = cityHallData[city as keyof typeof cityHallData];

  if (!cityData) {
    return <div>Cidade não encontrada</div>;
  }

  return <CityHallClient cityData={cityData} navigate={navigate} />;
}